import { Label } from '@cian/ui-kit';
import * as React from 'react';

import { IconProductSuperAgent16 } from '@cian/ui-kit-design-tokens/icons';

export type TSuperAgentBadgeProps = {
  levelName: string;
};

export const SuperAgentBadge = ({ levelName }: TSuperAgentBadgeProps) => {
  return (
    <Label
      data-testid="super-agent-badge"
      data-name="badgeSuperAgent"
      icon={<IconProductSuperAgent16 color="accent-positive-primary" />}
      background="accent-positive-secondary"
      color="accent-positive-primary"
    >
      {levelName}
    </Label>
  );
};
